import * as React from "react";
import { withTheme } from "styled-components";

import { OverlayEditorViewStyle } from "./overlay-editor-view-style";
import { RuntimeTheme } from "../../../lib/theme/theme";
import GrowingEntryView from "../growing-entry/growing-entry-view";

export interface OverlayEditorViewProps {
    value: string;

    className?: string;
    placeholder?: string;

    onChange: (newValue: string) => void;
}

interface Props extends OverlayEditorViewProps {
    theme: RuntimeTheme;
}

class OverlayEditorViewImpl extends React.PureComponent<Props> {
    private onInput = (ev: React.ChangeEvent<HTMLTextAreaElement>): void => {
        this.props.onChange(ev.target.value);
    };

    public render(): React.ReactNode {
        const { placeholder, value, className } = this.props;

        return (
            <OverlayEditorViewStyle className={className}>
                <GrowingEntryView onChange={this.onInput} value={value} placeholder={placeholder} autoFocus={true} />
            </OverlayEditorViewStyle>
        );
    }
}

const OverlayEditorView = withTheme(OverlayEditorViewImpl);
export default OverlayEditorView;
